module.exports = "/assets/site/images/tomegsport_eger.jpg?562fd8d58b10a965109c4dfcbf336f6f";